import { Link } from "react-router-dom";
import { scrollToId } from "../hooks/useLenis";
import { Phone, Mail, MapPin, Lock, AtSign, Instagram, BadgeCheck } from "lucide-react";

export const FooterSection = () => (
  <footer data-testid="footer-section" className="bg-night text-paper">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 lg:pt-24 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-14 border-b border-paper/10">
        <div className="lg:col-span-6">
          <div className="flex items-center gap-4">
            <img src="/assets/logo.png" alt="Oltre il Conflitto" className="h-16 w-16 object-cover rounded-full ring-1 ring-gold/40 bg-paper" />
            <div>
              <p className="font-serif font-semibold text-xl sm:text-2xl tracking-wide">OLTRE IL CONFLITTO</p>
              <p className="font-display text-xs tracking-[0.22em] text-gold font-semibold mt-1">MEDIAZIONE FAMILIARE</p>
            </div>
          </div>
          <p className="mt-6 font-serif italic text-lg text-paper/70 max-w-md leading-relaxed">
            Dal conflitto alla collaborazione genitoriale.
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="font-display text-xs uppercase tracking-[0.22em] text-gold font-semibold mb-5">Esplora</p>
          <div className="flex flex-col gap-3">
            {[
              ["manifesto", "Cos'è la mediazione"],
              ["percorsi", "Separazione, figli, costi"],
              ["chi-sono", "Chi sono"],
              ["faq", "Domande frequenti"],
              ["materiale", "Materiale informativo"],
              ["contatti", "Contatti"],
            ].map(([id, label]) => (
              <button key={id} onClick={() => scrollToId(id)} data-testid={`footer-link-${id}`}
                className="text-left text-sm text-paper/70 hover:text-gold transition-colors duration-300">
                {label}
              </button>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="font-display text-xs uppercase tracking-[0.22em] text-gold font-semibold mb-5">Contatti</p>
          <div className="flex flex-col gap-3 text-sm text-paper/70">
            <a href="tel:+393296330445" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-phone">
              <Phone size={14} /> +39 329 633 0445
            </a>
            <a href="mailto:valentina.maritato85@gmail.com" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-email">
              <Mail size={14} /> valentina.maritato85@gmail.com
            </a>
            <a href="mailto:valentina.maritato@pec.it" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-pec">
              <AtSign size={14} /> PEC: valentina.maritato@pec.it
            </a>
            <a href="https://www.instagram.com/oltre_ilconflitto" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-instagram">
              <Instagram size={14} /> @oltre_ilconflitto
            </a>
            <a href="https://airac.it" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-airac">
              <BadgeCheck size={14} /> Socia AIRAC — airac.it
            </a>
            <a href="https://cameradimediazionenazionale.it" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-cmn">
              <BadgeCheck size={14} /> Camera di Mediazione Nazionale
            </a>
            <span className="inline-flex items-center gap-2">
              <MapPin size={14} /> Via Claudio Crea, 25 — Crotone (KR)
            </span>
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-paper/50">
        <p>© 2026 Dott.ssa Valentina Maritato — Mediazione Familiare, Crotone. Tutti i diritti riservati.</p>
        <div className="flex items-center gap-5">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">
            Privacy
          </Link>
          <Link to="/admin" data-testid="footer-admin-link"
            className="inline-flex items-center gap-2 hover:text-gold transition-colors">
            <Lock size={12} /> Area riservata
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
